import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../../service/http-error-handler.service';
import { HttpUtil } from '../../service/common.http';
import { CommonServiceService } from '../../service/common-service.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(
    private httpErrorHandler: HttpErrorHandler,
    private httpUtil: HttpUtil,
    public commonService: CommonServiceService,
  ) {
    this.handleError = httpErrorHandler.createHandleError('WeeklyService');
  }
  private handleError: HandleError;

  public api = {
    add: (login) => login ? '/a/u/user/orders ' : '/a/orders', // 订单创建
    info: (orderId) => `/a/u/pay/native/${orderId}`,  // 调用微信支付
    result: (orderId) => `/a/wx/pay/result/${orderId}`,  // 查询支付结果
    save: (orderId) => `/a/u/order/result/${orderId}`,  // 保存支付结果
  };

  // 订单创建
  addOrders(params): Promise<any> {
    const login = this.commonService.getLocalStorageByKey('login');
    return this.httpUtil
      .postJson(this.api.add(login), params)
      .pipe(catchError(this.handleError('addOrders', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));
  }
  // 调用微信支付
  wxPay(orderId: number): Promise<any> {
    return this.httpUtil
      .get(this.api.info(orderId))
      .pipe(catchError(this.handleError('wxPay', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));
  }

  // 查询支付结果
  wxPayResult(orderId: number): Promise<any> {
    return this.httpUtil
      .get(this.api.result(orderId))
      .pipe(catchError(this.handleError('wxPayResult')))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));
  }

  // 保存支付结果
  wxPayResultSave(orderId, params: { result: number }): Promise<any> {
    return this.httpUtil
      .put(this.api.save(orderId), params)
      .pipe(catchError(this.handleError('wxPayResultSave', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));
  }
}
